// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IScheduledCalendarDto
 */
export interface IScheduledCalendarDto {
    /**
     * 
     * @type {number}
     * @memberof IScheduledCalendarDto
     */
    calendar_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IScheduledCalendarDto
     */
    scheduled_contribution_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IScheduledCalendarDto
     */
    calendar_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IScheduledCalendarDto
     */
    frequency_type?: IScheduledCalendarDtoFrequencyTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IScheduledCalendarDto
     */
    next_scheduled_date?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof IScheduledCalendarDto
     */
    plan_codes?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IScheduledCalendarDto
     */
    status?: IScheduledCalendarDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IScheduledCalendarDto
     */
    tax_type?: IScheduledCalendarDtoTaxTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IScheduledCalendarDto
     */
    start_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IScheduledCalendarDto
     */
    calendar_status?: IScheduledCalendarDtoCalendarStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IScheduledCalendarDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IScheduledCalendarDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    DEACTIVATED = 'DEACTIVATED',
    REMOVED = 'REMOVED'
}
/**
* @export
* @enum {string}
*/
export enum IScheduledCalendarDtoTaxTypeEnum {
    PRE_TAX = 'PRE_TAX',
    POST_TAX = 'POST_TAX'
}
/**
* @export
* @enum {string}
*/
export enum IScheduledCalendarDtoCalendarStatusEnum {
    ACTIVE = 'ACTIVE',
    DEACTIVATED = 'DEACTIVATED'
}


/**
 * Check if a given object implements the IScheduledCalendarDto interface.
 */
export function instanceOfIScheduledCalendarDto(value: object): value is IScheduledCalendarDto {
    return true;
}

export function IScheduledCalendarDtoFromJSON(json: any): IScheduledCalendarDto {
    return IScheduledCalendarDtoFromJSONTyped(json, false);
}

export function IScheduledCalendarDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IScheduledCalendarDto {
    if (json == null) {
        return json;
    }
    return {
        
        'calendar_id': json['calendarId'] == null ? undefined : json['calendarId'],
        'scheduled_contribution_id': json['scheduledContributionId'] == null ? undefined : json['scheduledContributionId'],
        'calendar_name': json['calendarName'] == null ? undefined : json['calendarName'],
        'frequency_type': json['frequencyType'] == null ? undefined : json['frequencyType'],
        'next_scheduled_date': json['nextScheduledDate'] == null ? undefined : (new Date(json['nextScheduledDate'])),
        'plan_codes': json['planCodes'] == null ? undefined : json['planCodes'],
        'status': json['status'] == null ? undefined : json['status'],
        'tax_type': json['taxType'] == null ? undefined : json['taxType'],
        'start_date': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'calendar_status': json['calendarStatus'] == null ? undefined : json['calendarStatus'],
    };
}

export function IScheduledCalendarDtoToJSON(json: any): IScheduledCalendarDto {
    return IScheduledCalendarDtoToJSONTyped(json, false);
}

export function IScheduledCalendarDtoToJSONTyped(value?: IScheduledCalendarDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'calendarId': value['calendar_id'],
        'scheduledContributionId': value['scheduled_contribution_id'],
        'calendarName': value['calendar_name'],
        'frequencyType': value['frequency_type'],
        'nextScheduledDate': value['next_scheduled_date'] == null ? undefined : ((value['next_scheduled_date']).toISOString().substring(0,10)),
        'planCodes': value['plan_codes'],
        'status': value['status'],
        'taxType': value['tax_type'],
        'startDate': value['start_date'] == null ? undefined : ((value['start_date']).toISOString().substring(0,10)),
        'calendarStatus': value['calendar_status'],
    };
}

